import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const EMOJIS = ["✨", "💜", "🎉", "💫", "🔥", "💖", "🪩", "⭐", "🌟", "💥"];

export default function Confetti({ show, count = 24, duration = 2600, className = "" }) {
    const [pieces, setPieces] = useState([]);

    useEffect(() => {
        if (!show) {
            setPieces([]);
            return;
        }
        const arr = Array.from({ length: count }, (_, i) => ({
            id: `${Date.now()}-${i}`,
            emoji: EMOJIS[Math.floor(Math.random() * EMOJIS.length)],
            dx: (Math.random() - 0.5) * 400,      // -200 .. 200
            dy: 260 + Math.random() * 340,        // fall distance
            rot: (Math.random() - 0.5) * 720,
            scale: 0.6 + Math.random() * 0.9,
            delay: Math.random() * 0.35,
            duration: duration / 1000 + Math.random() * 0.6,
        }));
        setPieces(arr);
    }, [show, count, duration]);

    return (
        <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden>
            <AnimatePresence>
                {show &&
                    pieces.map((p) => (
                        <motion.span
                            key={p.id}
                            className="confetti-piece"
                            initial={{ x: 0, y: -20, opacity: 0, rotate: 0, scale: p.scale }}
                            animate={{ x: p.dx, y: p.dy, opacity: [0, 1, 1, 0], rotate: p.rot }}
                            transition={{ duration: p.duration, delay: p.delay, ease: "easeOut" }}
                        >
                            {p.emoji}
                        </motion.span>
                    ))}
            </AnimatePresence>
        </div>
    );
}
